import React from "react";
import { ReactComponent as SwarmLogo } from "svg/SwarmLogo.svg";
import { ReactComponent as RightArrow } from "svg/right-arrow-head.svg";

const SwarmPromo = () => {
  return (
    <a href="https://u.gg/lol/swarm/build?utm_source=ugghometopbanner" className="swarm-promo-container">
      <SwarmLogo className="swarm-logo" />
      <div className="middle-section">
        <div className="top-text">
          <div className="new-tag">NEW</div>
          <div className="top-text-wide-screen">SWARM IS HERE, THIS SUMMER ONLY.</div>
          <div className="top-text-mobile">SWARM IS HERE.</div>
        </div>
        <div className="bottom-text wide-screen">Builds and tier lists to jump into Riot's new PvE mode.</div>
        <div className="bottom-text mobile">Builds to jump into Riot's new PvE mode.</div>
        <div className="third-row">
          <SwarmLogo className="swarm-logo" />
          <div className="cta-button">
            <span>Check out Swarm</span> <RightArrow className="arrow-icon" />
          </div>
        </div>
      </div>
      <div className="cta-button">
        <span>Check out Swarm</span> <RightArrow className="arrow-icon" />
      </div>
    </a>
  );
};

export default SwarmPromo;
